export default class XHR {
  static post (url, parameters = null) {
    const request = new XMLHttpRequest()
    const { params } = parameters
    let formdata = null

    return new Promise((resolve, reject) => {
      request.onreadystatechange = () => {
        // Return if request is not complete
        if (request.readyState !== 4) return

        // Process response
        if (request.readyState == 4 && request.status == 200) {
          return resolve(request)
        }

        // Reject if response could'nt get processed
        return reject({
          status: request.status,
          statusText: request.statusText
        })
      }

      // Setup parameters
      if (params) {
        formdata = new FormData()

        for (const key in params) {
          if (params.hasOwnProperty(key)) {
            formdata.append(key, params[key])
          }
        }
      }

      request.open('POST', url, true)
      request.send(formdata || null)
    })
  }
}
